<div class="modal-header">
  <h4 class="modal-title">Create a new agent</h4>
  <button type="button" class="close" (click)="activeModal.dismiss()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="agentForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="agentName">Name</label>
      <input
        type="text"
        class="form-control"
        id="agentName"
        formControlName="name"
        placeholder="Enter agent name" />
    </div>

    <div class="form-group">
      <label for="agentInstructions">Instructions</label>
      <textarea
        class="form-control"
        id="agentInstructions"
        rows="10"
        formControlName="instructions"
        placeholder="Example:&#10;&#10;Take a look at all assets in all buildings, find any that have been offline for longer than 4 hours and Send Channel Message to the product team with a list of the overdue tasks, who they're assigned to, and the dependencies. &#10;&#10;Include a link to the tasks in the message."></textarea>
      <div class="mt-2 d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-outline-secondary">
          <i class="fas fa-tools"></i> Insert tools
          <i class="fas fa-bolt ml-1"></i>
          <i class="fab fa-slack ml-1"></i>
          <i class="fas fa-globe ml-1"></i>
          <i class="fas fa-ellipsis-h ml-1"></i>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    [disabled]="agentForm.invalid">
    Create agent
  </button>
</div>
